// Module
var code = "<template> <require from=\"app/um/components/audit-log/auth-audit-log\"></require> <compose view-model=\"app/um/components/audit-log/auth-audit-log\" model.bind=\"modelData\"></compose> </template> ";
// Exports
module.exports = code;